import './polyfills';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@shared/redteam/cloudPluginMetadata';

import App from './App';
import { captureInviteFromUrl, captureInviteOnNavigation } from './utils/pendingInvite';
import './index.css';

// This must come before the first fetch and before any analytics SDK is initialized, both of
// which happen once the app mounts: neither may see a URL that holds an invite code. When the URL
// held one, the page is reloading without it and nothing is rendered.
if (!captureInviteFromUrl()) {
  captureInviteOnNavigation();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
